export const settings = {
  authenticateWithDescope: false,
  adminDashboardLayoutId: '954a1c6f-47a6-477f-b8a2-0050e5f30261',
  defaultModuleId: '236ed876-f804-4e99-888c-6a761c12385b',
  authenticateWithCredentials: true,
  adminHomePageId: '23c9e224-dc2a-4448-81de-709adebb33fb',
  adminModuleId: 'ddf60c8c-482c-4aa6-a022-a0e01d9664c9',
  usernameType: 'email',
  isAuthenticationEnabled: true,
  homePageId: '7aec9b1c-9abb-4389-91e9-72cdea3a527e',
  paymentProvider: 'not-provided',
};
